var _rect, _circle, _text, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#f0fdfa"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 110,
    r: 55,
    fill: "#ccfbf1"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 132,
    fontFamily: "Arial",
    fontSize: 60,
    fontWeight: "bold",
    fill: "#0d9488",
    opacity: 0.4
  }, "?")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 185,
    width: 90,
    height: 35,
    rx: 10,
    fill: "white",
    stroke: "#0d9488",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 196,
    width: 50,
    height: 5,
    rx: 2,
    fill: "#0d9488",
    opacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 206,
    width: 35,
    height: 5,
    rx: 2,
    fill: "#0d9488",
    opacity: 0.15
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 195,
    width: 90,
    height: 35,
    rx: 10,
    fill: "white",
    stroke: "#3b82f6",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 206,
    width: 50,
    height: 5,
    rx: 2,
    fill: "#3b82f6",
    opacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 216,
    width: 35,
    height: 5,
    rx: 2,
    fill: "#3b82f6",
    opacity: 0.15
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 268,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#115e59"
  }, "SSS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.2a7584c26028c165934ae185e0d17ef3.svg";
export { ForwardRef as ReactComponent };